import "../../../styles/app.scss";

import { debounce } from "lodash";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    InstitutionBreadcrumbs,
    InstitutionCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as HealthDistrictActions from "../../../actions/healthDistrict";
import * as InstitutionActions from "../../../actions/institution";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    SelectFormInput,
    TextAreaFormInput,
    TextFormInput,
    ValidationMessage,
} from "../../../components/form/index";
import { SOURCE_DOCUMENT_UPLOAD_VIEW } from "../../../components/form/inputs/FileUploadFormInput/FileUploadViews";
import { FileUploadFormInput } from "../../../components/form/inputs/FileUploadFormInput/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { GridRemove } from "../../../enumerations/GridRemove";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { SOURCE_DOCUMENT_FILE_CONFIGURATION } from "../../../helpers/file";
import {
    getFormPropertyLabel,
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { InstitutionSubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    IInstitutionReduxFormState,
    initialInstitutionState,
} from "../../../reducers/reactReduxForms/institution";
import { initialSourceDocumentState } from "../../../reducers/reactReduxForms/sourceDocument";
import {
    requiredSourceDocument,
    requiredText,
} from "../../../validators/index";

import "./InstitutionPage.scss";

interface IInstitutionPageParams {
    institutionId: number;
}

interface IInstitutionPageProps extends IRouterProps<IInstitutionPageParams> {
    form: Dtos.Institution & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IInstitutionReduxFormState;

    institutionId: number;

    // From state
    institution: Dtos.Institution;
    lookups: Dtos.Lookup[];

    loadingInstitution: boolean;
    loadInstitutionSuccess: boolean;
    loadInstitutionFailure: boolean;
    loadInstitutionErrorCode: string;

    savingInstitution: boolean;
    saveInstitutionSuccess: boolean;
    saveInstitutionFailure: boolean;

    creatingInstitution: boolean;
    createInstitutionSuccess: boolean;
    createInstitutionFailure: boolean;

    validatingInstitution: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];

    healthDistricts: Dtos.HealthDistrict[];
}

interface IInstitutionPageActions extends IRouterActions {
    clearInstitution: InstitutionActions.IInstitutionClearActionCreator;
    loadInstitution: InstitutionActions.IInstitutionLoadByIdActionCreator;

    saveInstitution: InstitutionActions.IInstitutionSaveActionCreator;
    createInstitution: InstitutionActions.IInstitutionCreateActionCreator;
    validateInstitution: InstitutionActions.IInstitutionValidateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

    clearHealthDistricts: HealthDistrictActions.IHealthDistrictClearActionCreator;
    loadHealthDistricts: HealthDistrictActions.IHealthDistrictLoadActionCreator;
}

type InstitutionPageProps = IInstitutionPageProps & IInstitutionPageActions;

const reduxFormName: string = "reduxForms.institution";

class InstitutionPage extends React.PureComponent<InstitutionPageProps, any> {
    hasBeenSubmitted: boolean;

    constructor(props: InstitutionPageProps) {
        super(props);

        this.state = {
            hasBeenSubmitted: false,
        };

        this.clearInstitution = this.clearInstitution.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
        this.debounceValidate = this.debounceValidate.bind(this);
    }

    componentDidMount() {
        const {
            loadInstitution,
            institutionId,
            createInstitution,
            permissions,
            setDrawerItems,
            setBreadcrumbs,
            loadHealthDistricts
        } = this.props;
        

        loadHealthDistricts();

        if (institutionId) {
            setDrawerItems(InstitutionSubMenu(institutionId, permissions));
            setBreadcrumbs(InstitutionBreadcrumbs(institutionId));
            loadInstitution(institutionId);
        } else if (!institutionId) {
            setBreadcrumbs(InstitutionCreateBreadcrumbs());
            createInstitution();
        }
    }

    componentDidUpdate(prevProps: InstitutionPageProps, _prevState) {
        const {
            institution,
            institutionId,
            form,
            navigate,
            loadInstitution,
            loadingInstitution,
            loadInstitutionSuccess,
            createInstitution,
            creatingInstitution,
            createInstitutionSuccess,
            savingInstitution,
            saveInstitutionSuccess,
            validationFailures,
            setDrawerItems,
            setBreadcrumbs,
            permissions,
            loadInstitutionFailure,
            loadInstitutionErrorCode,
        } = this.props;

        if (loadInstitutionFailure) {
            navigate(`/error/${loadInstitutionErrorCode}`);
        }

        if (institutionId && institution?.name) {
            setDrawerItems(InstitutionSubMenu(institutionId, permissions));
            setBreadcrumbs(
                InstitutionBreadcrumbs(institutionId, institution.name)
            );
        }

        if (institutionId && prevProps.institutionId != institutionId) {
            loadInstitution(institutionId);
        } else if (!institutionId && prevProps.institutionId) {
            createInstitution();
        }

        if (!loadingInstitution && prevProps.loadingInstitution) {
            if (loadInstitutionSuccess) {
                this.loadForm();
            }
        }

        if (form != prevProps.form) {
            this.debounceValidate();
        }

        if (!savingInstitution && prevProps.savingInstitution) {
            if (saveInstitutionSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate("/institutions");
                } else if (
                    !form.saveAndReturn &&
                    institutionId &&
                    institutionId > 0
                ) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !institutionId &&
                    institution &&
                    institution.id > 0
                ) {
                    navigate("/institutions/" + institution.id + "/details");
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingInstitution && prevProps.creatingInstitution) {
            if (createInstitutionSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearInstitution();
        loadForm(reduxFormName, initialInstitutionState);
        resetForm(reduxFormName);
    }

    clearInstitution() {
        this.props.clearInstitution();
        this.props.clearHealthDistricts();
    }

    showInstitution(): boolean {
        const { loadingInstitution, loadInstitutionSuccess } = this.props;

        if (!loadingInstitution && loadInstitutionSuccess) {
            return true;
        }

        return false;
    }

    debounceValidate = debounce(async () => {
        const hasBeenSubmitted = this.state?.hasBeenSubmitted;
        const { form, validatingInstitution, validateInstitution } = this.props;

        let changes: Dtos.Institution = {} as Dtos.Institution;

        if (form && hasBeenSubmitted && !validatingInstitution) {
            await validateInstitution(Object.assign({ ...form }, changes));
        }
    }, 250);

    render() {
        const { loadingInstitution } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.InstitutionView}
                loading={loadingInstitution}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingInstitution,
            permissions,
            institutionId,
            healthDistricts,
        } = this.props;
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                institutionId,
                permissions,
                Dtos.Permission.InstitutionUpdate,
                Dtos.Permission.InstitutionCreate
            );
        // const formDisabledOnEdit: boolean = !hasPermission || FormHelper.isEdit(formState, form);
        const formDisabled: boolean =
            !hasPermission ||
            savingInstitution ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);
        // const showContractingPartyAddress: boolean = (form && form.agreementAddressOptionId && form.agreementAddressOptionId == 3);
        const certificateId = lookups
            ?.find((item) => item.propertyName === "FileType")
            ?.values?.find((item) => item.value === "Certificate")?.id;
        const countryAustraliaId = lookups
            ?.find((item) => item.propertyName === "CountryId")
            ?.values?.find((item) => item.value === "Australia")?.id;

        let healthDistrictOptions = [];
        if (form.stateId && healthDistricts) {
            const filteredHealthDistricts = healthDistricts
                ?.filter((x) => x.stateId == form?.stateId)
                ?.map((x) => x.id);
            healthDistrictOptions = generateOptionsFromLookup(
                {
                    type: "Institution",
                    propertyName: "HealthDistrictId",
                    values: findLookup(
                        "Institution",
                        "HealthDistrictId",
                        lookups
                    )
                        ?.values?.filter((l) =>
                            filteredHealthDistricts?.includes(l.id)
                        )
                        ?.sort((a, b) => a.value.localeCompare(b.value)),
                } as Dtos.Lookup,
                form.healthDistrictId
            );
        }

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            name: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            formerNames: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            address: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            suburb: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-4",
                                                fieldClassName:
                                                    "col-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            phone: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-3",
                                                fieldClassName:
                                                    "col-12 col-xl-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            stateId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "institution",
                                                                "stateId",
                                                                lookups
                                                            ),
                                                            form.stateId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-4",
                                                fieldClassName:
                                                    "col-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            facsimileNumber: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-3",
                                                fieldClassName:
                                                    "col-12 col-xl-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            postcode: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-4",
                                                fieldClassName:
                                                    "col-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            compactusNumber: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-3",
                                                fieldClassName:
                                                    "col-12 col-xl-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            countryId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "Institution",
                                                                "CountryId",
                                                                lookups
                                                            ),
                                                            form.countryId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-4",
                                                fieldClassName:
                                                    "col-12 col-xl-8 generic-form-field",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    if (
                                                        value !==
                                                        countryAustraliaId
                                                    ) {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".modifiedMonashModelId",
                                                            null
                                                        );
                                                    }
                                                    changeForm(
                                                        reduxFormName +
                                                            ".countryId",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            modifiedMonashModelId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    form.countryId !==
                                                        countryAustraliaId,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "Institution",
                                                                "ModifiedMonashModelId",
                                                                lookups
                                                            ),
                                                            form.modifiedMonashModelId
                                                        ),
                                                    clearable: true,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-3",
                                                fieldClassName:
                                                    "col-12 col-xl-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            dateModified: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-4",
                                                fieldClassName:
                                                    "col-12 col-xl-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-6">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            approvedForParticipation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Approved For Participation",
                                                },
                                                inputLabel: " ",
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0 h-100",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-3",
                                                fieldClassName:
                                                    "col-12 col-xl-9 generic-form-field align-items-center",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            abn: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            additionalInformation: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextAreaFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            website: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            medicalWebsite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            surgicalWebsite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            radiationWebsite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            radiologyWebsite: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            researchGovernanceGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Research Governance</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            healthDistrictId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    !form.stateId,
                                                inputProps: {
                                                    options:
                                                        healthDistrictOptions,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-12 col-xl-2",
                                                fieldClassName:
                                                    "col-12 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            siteInsuranceCertificate: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Site Insurance Certificate</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "institution",
                                        {
                                            sourceDocumentForm: {
                                                type: RegistrationComponent.RegistrationSourceDocuments,
                                                label: " ",
                                                disabled: formDisabled,
                                                components: {
                                                    sourceDocuments: {
                                                        type: RegistrationComponent.RegistrationGrid,
                                                        formName:
                                                            "SourceDocument",
                                                        disabled: formDisabled,
                                                        label: "Add Source Document",
                                                        className:
                                                            "source-documents-source-documents",
                                                        minRows: 0,
                                                        columnStyles: [
                                                            {
                                                                width: undefined,
                                                                minWidth:
                                                                    "200px",
                                                            },
                                                            {
                                                                width: "15%",
                                                                minWidth:
                                                                    "100px",
                                                            },
                                                            {
                                                                width: "15%",
                                                                minWidth:
                                                                    "100px",
                                                            },
                                                            {
                                                                width: "20%",
                                                                minWidth:
                                                                    "150px",
                                                            },
                                                            {
                                                                width: "125px",
                                                            },
                                                        ],
                                                        removeConfig:
                                                            GridRemove.All,
                                                        addRow: (
                                                            gridComponent,
                                                            _index,
                                                            _array
                                                        ) => {
                                                            const state: Dtos.SourceDocument =
                                                                Object.assign({
                                                                    ...gridComponent.initialState,
                                                                });
                                                            return state;
                                                        },
                                                        components: {
                                                            name: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    TextFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Institution",
                                                                        "Certificate Name",
                                                                        formProperties
                                                                    ),
                                                                inputProps: {
                                                                    feedbackIcon:
                                                                        FontAwesomeIcons
                                                                            .Solid
                                                                            .BAN,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredText,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "Certificate name is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            certificateDate: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    DatePickerFormInputFabric,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Institution",
                                                                        "Date of Certificate",
                                                                        formProperties
                                                                    ),
                                                                validators: {
                                                                    required: (
                                                                        value
                                                                    ) =>
                                                                        value !=
                                                                        undefined,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "Date of certificate is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            expiryDate: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    DatePickerFormInputFabric,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Institution",
                                                                        "Expiry Date",
                                                                        formProperties
                                                                    ),
                                                                validators: {
                                                                    required: (
                                                                        value
                                                                    ) =>
                                                                        value !=
                                                                        undefined,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "Expiry date is required.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileInformation: {
                                                                type: RegistrationComponent.RegistrationControl,
                                                                inputType:
                                                                    FileUploadFormInput,
                                                                inputDisabled:
                                                                    formDisabled,
                                                                inputLabel:
                                                                    getFormPropertyLabel(
                                                                        "Institution",
                                                                        "Upload",
                                                                        formProperties
                                                                    ),
                                                                changeAction: (
                                                                    model,
                                                                    value,
                                                                    form,
                                                                    parentModel
                                                                ) => {
                                                                    changeForm(
                                                                        model,
                                                                        value
                                                                    );
                                                                    changeForm(
                                                                        reduxFormName +
                                                                            parentModel +
                                                                            ".fileType",
                                                                        certificateId
                                                                    );
                                                                    const inputValue: Dtos.TemporaryFileInformation =
                                                                        value;
                                                                    const sourceDocument: Dtos.SourceDocument =
                                                                        form;
                                                                    if (
                                                                        sourceDocument.fileInformation &&
                                                                        inputValue &&
                                                                        sourceDocument
                                                                            .fileInformation
                                                                            .state !=
                                                                            inputValue.state &&
                                                                        inputValue.state ==
                                                                            Dtos
                                                                                .FileState
                                                                                .Success &&
                                                                        !sourceDocument.name
                                                                    ) {
                                                                        changeForm(
                                                                            reduxFormName +
                                                                                parentModel +
                                                                                ".name",
                                                                            inputValue.temporaryFile.name.substr(
                                                                                0,
                                                                                inputValue.temporaryFile.name.lastIndexOf(
                                                                                    inputValue
                                                                                        .temporaryFile
                                                                                        .extension
                                                                                )
                                                                            )
                                                                        );
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    render: SOURCE_DOCUMENT_UPLOAD_VIEW,
                                                                },
                                                                validators: {
                                                                    required:
                                                                        requiredSourceDocument,
                                                                },
                                                                errors: {
                                                                    required:
                                                                        "File must be uploaded.",
                                                                },
                                                                errorComponent:
                                                                    ValidationMessage,
                                                            },
                                                            fileConfiguration: {
                                                                type: RegistrationComponent.RegistrationGridElement,
                                                                label: " ",
                                                                render: SOURCE_DOCUMENT_FILE_CONFIGURATION,
                                                            },
                                                        },
                                                        initialState: {
                                                            ...initialSourceDocumentState,
                                                        },
                                                    },
                                                },
                                                keyReplace: "sourceDocuments",
                                                onRemove: (model: string) => {
                                                    changeForm(
                                                        model + "active",
                                                        false
                                                    );
                                                    return true; // this was handled here
                                                },
                                                filterRow: (
                                                    data: Dtos.SourceDocument
                                                ) => {
                                                    if (data.active != true) {
                                                        return false;
                                                    }
                                                    return true;
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "institution",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(
                                reduxFormName + ".saveAndReturn",
                                false
                            );
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(
                                reduxFormName + ".saveAndReturn",
                                true
                            );
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button
                        onClick={this.onCancel}
                        className="btn btn-primary mr-2"
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </Form>
        );
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return (
            <div>The form has been saved successfully</div>
        );
    }

    handleOnSubmit(data: Dtos.Institution) {
        const { hasBeenSubmitted } = this.state;
        const { saveInstitution } = this.props;

        if (!hasBeenSubmitted) {
            this.setState({ hasBeenSubmitted: true });
        }

        if (data) {
            let changes: Dtos.Institution = {} as Dtos.Institution;
            saveInstitution(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.Institution) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { navigate } = this.props;

        navigate("/institutions");
    }

    loadForm() {
        const { loadForm, institution } = this.props;

        let extraData: Dtos.Institution = {} as Dtos.Institution;

        loadForm(reduxFormName, Object.assign({ ...institution }, extraData));
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: InstitutionPageProps
): IInstitutionPageProps => {
    let institution: Dtos.Institution | undefined = !(
        state.institutions.formData instanceof Array
    )
        ? state.institutions.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        match: ownProps.match,
        institutionId:
            ownProps.match &&
            ownProps.match.params.institutionId &&
            ownProps.match.params.institutionId.toString() != "create"
                ? ownProps.match.params.institutionId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        institution: institution!,

        loadingInstitution:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionSuccess:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Success,
        loadInstitutionFailure:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Failure,
        loadInstitutionErrorCode: state.institutions.loadState.errorCode,

        savingInstitution:
            state.institutions.saveState &&
            state.institutions.saveState.status == RequestState.Pending,
        saveInstitutionSuccess:
            state.institutions.saveState &&
            state.institutions.saveState.status == RequestState.Success,
        saveInstitutionFailure:
            state.institutions.saveState &&
            state.institutions.saveState.status == RequestState.Failure,

        creatingInstitution:
            state.institutions.createState &&
            state.institutions.createState.status == RequestState.Pending,
        createInstitutionSuccess:
            state.institutions.createState &&
            state.institutions.createState.status == RequestState.Success,
        createInstitutionFailure:
            state.institutions.createState &&
            state.institutions.createState.status == RequestState.Failure,

        validatingInstitution:
            state.institutions.validateState &&
            state.institutions.validateState.status == RequestState.Pending,

        user: state.user.data,
        permissions: permissions,
        lookups: state.institutions.lookups,

        form: state.reduxForms.institution,
        formState: state.institutions.formState,
        formProperties: state.institutions.formProperties,

        reduxFormState: state.reduxForms.formState.institution,
        validationFailures: institution
            ? state.institutions.validationFailures
            : undefined,

        healthDistricts: state.healthDistricts.formFilteredData!,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: InstitutionPageProps
): IInstitutionPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadInstitution: bindActionCreators(
            InstitutionActions.LoadInstitutionById,
            dispatch
        ),
        clearInstitution: bindActionCreators(
            InstitutionActions.Clear,
            dispatch
        ),

        saveInstitution: bindActionCreators(
            InstitutionActions.SaveInstitution,
            dispatch
        ),
        createInstitution: bindActionCreators(
            InstitutionActions.CreateInstitution,
            dispatch
        ),
        validateInstitution: bindActionCreators(
            InstitutionActions.ValidateInstitution,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        ),

        loadHealthDistricts: bindActionCreators(
            HealthDistrictActions.LoadHealthDistrict,
            dispatch
        ),
        clearHealthDistricts: bindActionCreators(
            HealthDistrictActions.Clear,
            dispatch
        )
    };
};

export default RouterHoc<IInstitutionPageParams, InstitutionPageProps>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(InstitutionPage) as unknown as ComponentType<InstitutionPageProps>
) as ComponentType<any>;
